import { useTheme } from "@stores/ThemeContext";
import { T, OVERVIEW_EVENTS } from "@utils/enums";
import goal from '@assets/svg/statsConsoleAndOverview/matchEvents/goal.svg';
import goal_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/goal_dark.svg';
import penatly_saved from '@assets/svg/statsConsoleAndOverview/matchEvents/penalty_saved.svg';
import penatly_saved_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/penalty_saved_dark.svg';
import yellow_card from '@assets/svg/statsConsoleAndOverview/matchEvents/yellow_card.svg';
import yellow_card_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/yellow_card_dark.svg';
import corner from '@assets/svg/statsConsoleAndOverview/matchEvents/corner.svg';
import corner_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/corner_dark.svg';
import injury_break from '@assets/svg/statsConsoleAndOverview/matchEvents/injury_break.svg';
import injury_break_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/injury_break_dark.svg';
import offside from '@assets/svg/statsConsoleAndOverview/matchEvents/offside.svg';
import offside_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/offside_dark.svg';
import penalty_awarded from '@assets/svg/statsConsoleAndOverview/matchEvents/penalty_awarded.svg';
import penalty_awarded_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/penalty_awarded_dark.svg';
import penalty_missed from '@assets/svg/statsConsoleAndOverview/matchEvents/penalty_missed.svg';
import penalty_missed_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/penalty_missed_dark.svg';
import red_card from '@assets/svg/statsConsoleAndOverview/matchEvents/red_card.svg';
import red_card_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/red_card_dark.svg';
import shot_off_the_target from '@assets/svg/statsConsoleAndOverview/matchEvents/shot_off_the_target.svg';
import shot_off_the_target_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/shot_off_the_target_dark.svg';
import shot_on_the_target from '@assets/svg/statsConsoleAndOverview/matchEvents/shot_on_the_target.svg';
import shot_on_the_target_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/shot_on_the_target_dark.svg';
import substitute from '@assets/svg/statsConsoleAndOverview/matchEvents/substitute.svg';
import substitute_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/substitute_dark.svg';
import var_check from '@assets/svg/statsConsoleAndOverview/matchEvents/var_check.svg';
import var_check_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/var_check_dark.svg';
import var_declined from '@assets/svg/statsConsoleAndOverview/matchEvents/var_declined.svg';
import var_declined_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/var_declined_dark.svg';
import varSVG from '@assets/svg/statsConsoleAndOverview/matchEvents/var.svg';
import var_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/var_dark.svg';
import own_goal from '@assets/svg/statsConsoleAndOverview/matchEvents/own_goal.svg';
import own_goal_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/own_goal_dark.svg';
import second_yellow_card from '@assets/svg/statsConsoleAndOverview/matchEvents/second_yellow_card.svg';
import second_yellow_card_dark from '@assets/svg/statsConsoleAndOverview/matchEvents/second_yellow_card_dark.svg';
import { useContext, useEffect } from "react";
import { StateContext } from "../../../../../state/stateContext";

interface IEventIconAndTimeProps {
    time: string | null;
    iconName: string;
}

export const EventIconAndTime = ({ iconName, time }: IEventIconAndTimeProps) => {
    const { theme } = useTheme();
    const ctx = useContext(StateContext);
    const { stContext, setStContext } = ctx || {};
    const { overviewEventAndTimeWidth } = stContext || {};


    const switchIcon = () => {
        switch (iconName) {
            case OVERVIEW_EVENTS.PENALTIES_MISSED:
                return <img src={theme === T.DARK ? penalty_missed_dark : penalty_missed} alt="penalty_missed" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.GOAL:
                return <img src={theme === T.DARK ? goal_dark : goal} alt="goal" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.OWN_GOAL:
                return <img src={theme === T.DARK ? own_goal_dark : own_goal} alt="own_goal" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.PENALTIES_GOAL:
                return <img src={theme === T.DARK ? goal_dark : goal} alt="goal" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.PENALTIES_SAVED:
                return <img src={theme === T.DARK ? penatly_saved_dark : penatly_saved} alt="penalties_saved" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.PENALTY_SAVED:
                return <img src={theme === T.DARK ? penatly_saved_dark : penatly_saved} alt="penalty_saved" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.YELLOW_CARD:
                return <img src={theme === T.DARK ? yellow_card_dark : yellow_card} alt="yellow_card" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.SECOND_YELLOW_CARD:
                return <img src={theme === T.DARK ? second_yellow_card_dark : second_yellow_card} alt="second_yellow_card" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.CORNER:
                return <img src={theme === T.DARK ? corner_dark : corner} alt="corner" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.INJURY_BREAK:
                return <img src={theme === T.DARK ? injury_break_dark : injury_break} alt="injury_break" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.OFFSIDE:
                return <img src={theme === T.DARK ? offside_dark : offside} alt="offside" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.PENALTY_AWARDED:
                return <img src={theme === T.DARK ? penalty_awarded_dark : penalty_awarded} alt="penalty_awarded" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.PENALTY_MISSED:
                return <img src={theme === T.DARK ? penalty_missed_dark : penalty_missed} alt="penalty_missed" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.RED_CARD:
                return <img src={theme === T.DARK ? red_card_dark : red_card} alt="red_card" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.SHOT_OFF_THE_TARGET:
                return <img src={theme === T.DARK ? shot_off_the_target_dark : shot_off_the_target} alt="shot_off_the_target" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.SHOT_ON_THE_TARGET:
                return <img src={theme === T.DARK ? shot_on_the_target_dark : shot_on_the_target} alt="shot_on_the_target" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.SUBSTITUTE:
                return <img src={theme === T.DARK ? substitute_dark : substitute} alt="substitute" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.VAR_CHECK:
                return <img src={theme === T.DARK ? var_check_dark : var_check} alt="var_check" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.VAR_DECLINED:
                return <img src={theme === T.DARK ? var_declined_dark : var_declined} alt="var_declined" style={{ width: '16px', height: '16px' }} />
            case OVERVIEW_EVENTS.VAR:
                return <img src={theme === T.DARK ? var_dark : varSVG} alt="var" style={{ width: '16px', height: '16px' }} />
            default:
                return <img src={theme === T.DARK ? goal_dark : goal} alt="goal" style={{ width: '16px', height: '16px' }} />
        }
    }

    return (
        <div data-testid="overview-event-icon-and-time"
            className='flex flex-col justify-center items-center'>
            {switchIcon()}
            <div className={`leading-[16px] font-normal font-robotoRegular text-base0 dark:text-base090 flex justify-center items-center`}
                style={{ fontSize: '12px', width: `${overviewEventAndTimeWidth}px` }}>
                {time ? time + '’' : `${'\u00A0'}`}
            </div>
        </div>
    )
}
